export default function clientMiddleware(client) {
  return ({ dispatch, getState }) =>
    next => action => {
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      const { promise, types, ...rest } = action; // eslint-disable-line no-use-before-define
      if (!promise) {
        return next(action);
      }

      const [REQUEST, SUCCESS, FAILURE] = types;
      next({ ...rest, type: REQUEST });

      const actionPromise = promise(client);
      actionPromise.then(
        (result) => next({ ...rest, result, type: SUCCESS }),
        (error) => next({ ...rest, error, type: FAILURE })
      ).catch((error) => {
        console.error('MIDDLEWARE ERROR:', error);
        console.error('MIDDLEWARE ERROR:', error.stack);
        next({ ...rest, error, type: FAILURE });
      });

      return actionPromise;
    };
}



// WEBPACK FOOTER //
// ./Scripts/redux/middleware/clientMiddleware.js